<template>
  <main-layout>
    <v-tabs>
      <v-tab v-for="(tab, index) in tabs" :key="index" :to="tab.to">{{ tab.text }}</v-tab>
    </v-tabs>
    <div class="pa-3">
      <router-view />
    </div>
  </main-layout>
</template>

<script>
export default {
  name: 'AssetWiseManagement',
  provide() {
    return {
      landStatusText: {
        undecided: this.$t('asset_wise.land_status.undecided'),
        considering: this.$t('asset_wise.land_status.considering'),
        stage1: this.$t('asset_wise.land_status.stage1'),
        stage2: this.$t('asset_wise.land_status.stage2'),
        deposit: this.$t('asset_wise.land_status.deposit')
      }
    }
  },
  data() {
    return {
      tabs: [
        {
          text: this.$t('asset_wise.land_sales'),
          to: {
            name: 'assetwise-management-land-sales'
          }
        },
        {
          text: this.$t('asset_wise.executive_records'),
          to: {
            name: 'assetwise-management-executive-records'
          }
        },
        {
          text: this.$t('asset_wise.broker_details'),
          to: {
            name: 'assetwise-management-brokers'
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/index.vue